var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Container"},[_c('div',{class:['Brick', 'Left', _vm.previewtop ? 'Off' : 'On']},[_c('div',{class:['IconLeft', _vm.previewtop ? 'IconOff' : 'IconOn']})]),_c('div',{class:['Brick', 'Right', _vm.previewtop ? 'On' : 'Off']},[_c('div',{class:['IconRight', _vm.previewtop ? 'IconOn' : 'IconOff']})])])
}
var staticRenderFns = []

export { render, staticRenderFns }